import React from 'react';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

// ToggleButtonGroup Component
const useToggleButtonGroupStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
  },
}));

export const ToggleButtonGroup = ({
  value,
  onChange,
  exclusive = false,
  disabled = false,
  children,
  className,
  ...props
}) => {
  const classes = useToggleButtonGroupStyles();

  const handleChange = (event, buttonValue) => {
    if (!onChange) return;

    if (exclusive) {
      // Single selection mode
      if (value !== buttonValue) {
        onChange(event, buttonValue);
      }
    } else {
      // Multiple selection mode
      const newValue = Array.isArray(value) ? [...value] : [];
      const index = newValue.indexOf(buttonValue);

      if (index > -1) {
        newValue.splice(index, 1);
      } else {
        newValue.push(buttonValue);
      }

      onChange(event, newValue);
    }
  };

  const isSelected = (buttonValue) => {
    if (exclusive) {
      return value === buttonValue;
    }
    return Array.isArray(value) && value.indexOf(buttonValue) > -1;
  };

  return (
    <ButtonGroup className={clsx(classes.root, className)} {...props}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return null;

        return React.cloneElement(child, {
          selected: isSelected(child.props.value),
          onChange: handleChange,
          disabled: disabled || child.props.disabled,
        });
      })}
    </ButtonGroup>
  );
};